export default __webpack_public_path__ + "8c08af83180f8d1cd35748bb03f4a003.png";